import loading from "../images/loadinglogo.gif";

const LoadSpinner = () => (
  <div style={{ display: "flex", justifyContent: "center", marginTop: "200px" }}>
    <img src={loading} alt="Click to return to choose" width="300" height="300" className="d-inline-block align-top" />
  </div>
);

export default LoadSpinner;
